import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./support.component.css'],
})
export class SupportComponent implements OnInit {
  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  constructor() {}

  ngOnInit(): void {}
}
